/** Entry point of the in-browser demo bundle. See demo/runtime.ts. */
import { boot, serverFetch } from "./runtime"
import { startUi } from "./ui"

declare global {
  interface Window {
    __sibylFetch?: (url: string, init?: RequestInit) => Promise<Response>
    __sibylResolve?: () => void
  }
}

try {
  await boot()
  window.__sibylFetch = serverFetch
  window.__sibylResolve?.()
  await startUi()
  document.documentElement.dataset["demoReady"] = "1"
} catch (e) {
  // ⛔ A demo that failed to start must say so on the page, not sit on an empty queue.
  const div = document.createElement("div")
  div.setAttribute("role", "alert")
  div.style.cssText = "position:fixed;inset:auto 12px 12px 12px;z-index:99;padding:12px 14px;border-radius:10px;background:#3a1212;color:#ffd9d9;font:13px ui-monospace,monospace;white-space:pre-wrap"
  div.textContent = `The demo could not start: ${e instanceof Error ? `${e.message}\n${e.stack ?? ""}` : String(e)}`
  document.body.appendChild(div)
  document.documentElement.dataset["demoReady"] = "error"
  throw e
}
